<article class="bg-white mt-6 px-4 lg:px-6 py-2.5">
    <div class="justify-between items-start mx-auto max-w-screen-xl">
        <h1 id="nav-innovationsvorhaben" class="text-center mb-8">Innovationsvorhaben</h1>
        <p class="mx-32 mt-5 text-justify">
            <span>
                Unsere Laborideen werden durch verschiedene Materialien unterstützt und sind dadurch vielseitig einsetzbar.
                Das erleichtert den Umgang für Nutzerinnen und Nutzer erheblich. Diese Materialien evidenzbasiert zu aktualisieren
                und weiterzuentwickeln gehört zu den Prioritäten dieses Projekts. Dahingehend sind alle Personen mit Ideen für
                solche Materialien eingeladen, diese mit uns zu teilen, damit die nötige Unterstützung geboten werden kann,
                um neue Innovationsvorhaben umzusetzen und den Entwicklungsprozess professionell zu begleiten.
                So sind Ideen und Wünsche in verschiedene Richtungen willkommen. Das Projekt ist offen für Ideen zu konkreten Materialien,
                als auch neuen Formaten, Methoden, Maßnahmen, Themen und Konzepten. Wir freuen uns über Ihre Kontaktaufnahme,
                um Sie bei Ihrem Innovationsvorhaben, im Rahmen der Möglichkeiten, zu unterstützen. Ihre Arbeit darf dabei
                nicht gewinnorientiert sein und Ihre Ergebnisse müssen als Open Educational Ressources (OER) der Allgemeinheit
                zur Verfügung gestellt werden.
            </span>
            <br/><br/>
        </p>

        <div class="flex justify-center">
            <div class="block p-6 rounded-lg shadow-lg bg-slate-200 max-w-sm my-6">
                  <h5 class="text-slate-900 text-xl leading-tight font-medium mb-2">Ansprechpartner</h5>
                  <p class="text-slate-700 text-base mb-4">
                    Ingrid Krumphals<br/>
                    Pädagogische Hochschule Steiermark<br/>
                    ingrid.krumphals [at] phst [punkt] at
                  </p>
            </div>
        </div>
    </div>
</article>
